import React from "react";
import { connect } from "react-redux";
import Axios from "Source/axiosPool";
import _ from "lodash";

import Avatar from "Components/common/Avatar/Avatar";
import AddWorkstreamAction from "Components/workstream/Actions/AddWorkstreamAction/AddWorkstreamAction";
import AddWorkstream from "Components/workstream/modal/AddWorkstream/AddWorkstream";
import Row from "./Row/Row";
import ManageMembersModal from "Components/project/Workstreams/Modal/ManageMembers/ManageMembers";
import ReassignLeadModal from "Components/project/Workstreams/Modal/ReassignLead/ReassignLead";
import RemoveUserModal from "Components/project/Workstreams/Modal/RemoveUser/RemoveUser";
import DeleteWorkstream from "Components/project/Workstreams/Modal/DeleteWorkstream/DeleteWorkstream";
import ReassignTask from "Components/project/Workstreams/Modal/ReassignTask/ReassignTask";
import Button from "@/src/components/common/Elements/Button/Button";

@connect(store => {
    return {
        workstream: store.workstream,
        loggedUser: store.loggedUser,
        project: store.project
    }
})

class Workstreams extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            page: 1,
        }

        _.map(["onFetchWorkstream"], fn => {
            this[fn] = this[fn].bind(this);
        });
        
    }

    shouldComponentUpdate( nextProps ) {
        if( !_.isEqual( nextProps.workstream.IsUpdated, this.props.workstream.IsUpdated ) && nextProps.workstream.IsUpdated ) {
            this.onFetchWorkstream();
        } 

        return true;
    }

    componentDidMount() {
        this.onFetchWorkstream();
    }

    onFetchWorkstream(newPage) {
        const { dispatch, loggedUser, project, workstream, match } = this.props;
        const { typeId, workstreamStatus, workstream: workstreamFilter } = workstream.Filter;
        const url = "api/workstream";
        const page = newPage
            ? newPage
            : this.state.page;
            
        const params = {
            projectId: project.Selected.id,
            userId: loggedUser.data.id,
            userRole: loggedUser.data.userRole,
            typeId,
           // workstreamStatus:'All',
            workstream: workstreamFilter,
            isDeleted: 0,
            section: 'settings',
            page,
        };

        dispatch({ type: "SET_SCREEN_LOADER", Loading: true }); 

        Axios.get(url, params)
            .then(response => {
                if( response ) {
                    dispatch({ type: "UPDATE_WORKSTREAM_LIST", list: response.data.result, Count: response.data.count });
                }

                dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                dispatch({ type: "SET_WORKSTREAM_UPDATED", boolean: false });
                
                this.setState(prevState => ({
                    ...prevState,
                    page
                }))
            })
    }

    handleLoadMore = () => {
        const { page } = this.state;

        this.onFetchWorkstream(page + 1);
    }

    render() {
        const { workstream, project, loggedUser,hasChanges } = this.props;
        const isAccountLead = loggedUser.data.id === project.Selected.leadId;
        const enableActionsWorkstreams = (
            isAccountLead || 
            loggedUser.data.userRole < 3 || 
            (loggedUser.data.userRole === 4 && project.Selected.type && (project.Selected.type.type === "Private" || project.Selected.type.type === "Internal")) ||
            project.Selected.projectManagerId === loggedUser.data.id
        );
        const hasMore = workstream.Count.current_page < workstream.Count.last_page;
        return (
            <div class="memberFormsContainer">
                <div class="memberFormContainer mt0">
                    <div class="memberFormsHeader">
                        <h4>Workstreams</h4>
                        { enableActionsWorkstreams && <AddWorkstreamAction triggerEdit={this.props.triggerEdit}
                                    hasChanges={this.props.hasChanges} isEdit={this.props.isEdit} isOpen={this.props.isOpen} onCancel={this.props.onCancel}/> }
                    </div>
                    <div class="workstreamsList memberFormBody container--scrollableTable">
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '15%' }}>Name</th>
                                    <th style={{ width: '15%' }}>Status</th>
                                    <th style={{ width: '15%' }}>Lead</th>
                                    <th style={{ width: '25%' }}>Workstream Email</th>
                                    <th style={{ width: '16%' }}>Member/s</th>
                                    <th style={{ width: '5%' }}>{/*  empty header  */}</th>
                                </tr>
                            </thead>
                            <tbody>
                                { workstream.List.map( w => (
                                    <Row key={ w.id } workstream={ w } triggerEdit={this.props.triggerEdit}
                                    hasChanges={this.props.hasChanges} isEdit={this.props.isEdit}/>
                                )) }

                                {hasMore && 
                                    <tr className="tableFooter">
                                        <td colSpan={6}>
                                            <div className="container--footer">
                                                <Button onClick={this.handleLoadMore}> Load More</Button>
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <AddWorkstream />
                <DeleteWorkstream />
                <ManageMembersModal projectId={this.props.project.Selected.id} />
                <ReassignLeadModal projectId={this.props.project.Selected.id} />
                <RemoveUserModal projectId={this.props.project.Selected.id} />
                <ReassignTask projectId={this.props.project.Selected.id} />
            </div>
        );
    }
}

export default Workstreams;